import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../../display'
import type { Feature } from '../feature'

/** Announces inventory and file-selection failures. */
export const showErrors = store.effects.create(
  (feature: Feature, toasterFeature: display.toaster.Feature) =>
    rxjs
      .merge(
        feature.actions.load.error.observe(),
        feature.actions.loadTenants.error.observe(),
        feature.actions.loadZones.error.observe(),
        feature.actions.selectFile
          .observe()
          .pipe(
            rxjs.filter(
              action =>
                action.data !== undefined &&
                action.data.size >
                  ents.core.agent.KnowledgeBase.Management
                    .MAXIMUM_FILE_SIZE_BYTES,
            ),
          ),
      )
      .pipe(
        rxjs.tap(() =>
          toasterFeature.actions.show
            .from('Admin.KnowledgeBases.Management.Error')
            .dispatch({
              toast: {
                description:
                  feature.selectors.operationError.asSignal() ??
                  'The knowledge base operation could not be completed.',
                name: 'Knowledge base operation failed',
                style: ents.core.display.Style.Error,
              },
            }),
        ),
        rxjs.ignoreElements(),
      ),
)
